<script>
import Loader from '@phoenix/components/common/Loader.vue';

export default {
  components: {
    Loader,
  },

  props: {
    boxSize: {
      type: String,
      default: 'xl',
    },
    centerBox: {
      type: Boolean,
      default: true,
    },
    theme: {
      type: String,
      default: 'dark',
    },
    loaderSize: {
      type: String,
      default: '',
    },
    whiteBox: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    containerClass() {
      return ['box', `box--${this.boxSize}`, { 'box--center': this.centerBox }, { 'box--white': this.whiteBox }];
    },
  },
};
</script>

<template>
  <div :class="containerClass" role="presentation">
    <loader :theme="theme" :size="loaderSize" />
  </div>
</template>
